import { Dialog } from './Dialog';
import { Button } from './Button';
import { AlertCircle } from 'lucide-react';

interface AlertDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  showConfirmButton?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
}

export function AlertDialog({
  open,
  onClose,
  title = '알림',
  message,
  showConfirmButton = true,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
}: AlertDialogProps) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      widthClass="max-w-md"
      onSubmit={showConfirmButton && onConfirm ? handleConfirm : undefined}
      footer={
        showConfirmButton ? (
          <div className="flex justify-end gap-2">
            {onConfirm && (
              <Button onClick={handleCancel} variant="outline">
                {cancelText}
              </Button>
            )}
            <Button onClick={handleConfirm} variant="default">
              {confirmText}
            </Button>
          </div>
        ) : undefined
      }
    >
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-gray-700">{message}</p>
      </div>
    </Dialog>
  );
}
